import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const LocationSection = ({ business }) => {
  const [showMap, setShowMap] = useState(false);

  // Mock coordinates for demonstration
  const mockLat = 51.5074;
  const mockLng = -0.1278;

  return (
    <div className="bg-card rounded-lg p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-heading font-semibold text-foreground">
          Location & Contact
        </h2>
        <button
          onClick={() => setShowMap(!showMap)}
          className="flex items-center space-x-2 text-primary hover:text-primary/80 font-body font-medium transition-gentle"
        >
          <Icon name={showMap ? 'EyeOff' : 'Map'} size={16} />
          <span>{showMap ? 'Hide Map' : 'Show Map'}</span>
        </button>
      </div>
      {/* Address Information */}
      <div className="space-y-4 mb-6">
        <div className="flex items-start space-x-3">
          <Icon name="MapPin" size={20} className="text-primary mt-1 flex-shrink-0" />
          <div>
            <p className="font-body font-medium text-foreground">
              {business?.fullAddress || business?.location}
            </p>
            {business?.postcode && (
              <p className="text-muted-foreground font-body text-sm">
                {business?.postcode}
              </p>
            )}
          </div>
        </div>
      </div>
      {/* Contact Information */}
      <div className="pt-4 border-t border-border">
        <h3 className="font-body font-medium text-foreground mb-2">Contact</h3>
        <div className="space-y-2">
          {business?.phone && (
            <div className="flex items-center space-x-2">
              <Icon name="Phone" size={16} className="text-muted-foreground" />
              <a 
                href={`tel:${business?.phone}`}
                className="text-primary hover:text-primary/80 font-body transition-gentle"
              >
                {business?.phone}
              </a>
            </div>
          )}
          {business?.email && (
            <div className="flex items-center space-x-2">
              <Icon name="Mail" size={16} className="text-muted-foreground" />
              <a 
                href={`mailto:${business?.email}`}
                className="text-primary hover:text-primary/80 font-body transition-gentle"
              >
                {business?.email}
              </a>
            </div>
          )}
          {business?.website && (
            <div className="flex items-center space-x-2">
              <Icon name="Globe" size={16} className="text-muted-foreground" />
              <a 
                href={business?.website?.startsWith('http') ? business?.website : `https://${business?.website}`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary hover:text-primary/80 font-body transition-gentle"
              >
                {business?.website?.replace(/^https?:\/\//, '')}
              </a>
            </div>
          )}
        </div>
      </div>
      {/* Map */}
      {showMap && (
        <div className="h-64 rounded-lg overflow-hidden border border-border">
          <iframe
            width="100%"
            height="100%"
            loading="lazy"
            title={`${business?.name} location`}
            referrerPolicy="no-referrer-when-downgrade"
            src={`https://www.google.com/maps?q=${mockLat},${mockLng}&z=14&output=embed`}
            className="w-full h-full"
          />
        </div>
      )}
      {/* Opening Hours */}
      {business?.openingHours && (
        <div className="mt-6 pt-6 border-t border-border">
          <h3 className="text-lg font-heading font-medium text-foreground mb-3">
            Opening Hours
          </h3>
          <div className="space-y-2">
            {Object.entries(business?.openingHours)?.map(([day, hours]) => (
              <div key={day} className="flex justify-between items-center">
                <span className="font-body text-foreground capitalize">
                  {day}
                </span>
                <span className="font-body text-muted-foreground">
                  {hours}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default LocationSection;